module.exports = "/_next/static/images/6f664311507bae7c4f82df98c081c900-worldcup-md-2x.jpg.webp";